/**
 * Normalized Log Analysis score (0-100). A perfect run (all suspicious events
 * picked, no false positives) yields 100; missed suspicious events and false
 * positives subtract from the earned total. With no suspicious events present
 * the task is trivially perfect and returns 100.
 */
import { calculatePickScore } from "./pickScore";
import { logFalsePositivePenalty, pickMissPenalty } from "./skillEffects";

export function calculateLogAnalysisScore(
  events: readonly { isSuspicious: boolean }[],
  selectedIndexes: ReadonlySet<number>,
  falsePositiveGuard = false,
  logAnalysisLevel = 0,
): number {
  return calculatePickScore(
    events.map((event) => ({ positive: event.isSuspicious })),
    selectedIndexes,
    pickMissPenalty(logAnalysisLevel),
    logFalsePositivePenalty(falsePositiveGuard),
  );
}
